import React, { useEffect, useState } from "react";
import Box from "../../../images/boxes.svg";
import BoxOrange from "../../../images/box_orange.svg";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import { format } from "date-fns";
import Button from "../../../components/shared/buttons/button";
import RefrigerationModal from "./RefrigerationModal";
import UpdateRefrigerationPendingKgModal from "./UpdateRefrigerationPendingKgModal";
import {
  useGetBrokerageRefrigerationDataQuery,
  useGetRefrigerationSummaryQuery,
} from "../materialEntered/materialApi";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, formatPalletName, getCurrentDate  } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const BrokerageRefrigeration = () => {

  const { _t } = useTranslator();  
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState({});
  const [lotNumber , setLotNumber] = useState(getCurrentDate("DDMMYY"));
  

  const { data: summaryData, refetch: refetchSummary } = useGetRefrigerationSummaryQuery({});

  const { 
          data: refrigerationData , 
          isLoading,
          isFetching,
          isError,
          error,  refetch  } = useGetBrokerageRefrigerationDataQuery({
            date,
            page,
            ...filter
          });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleAddRefrigerationData = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };

  const [showUpdateKgModal, setShowUpdateKgModal] = useState(false);

  const handleEditPendingKg = () => {
    setShowUpdateKgModal(true);
  };

  const packingTypeOptions = [
    { value: "prime_cheek_10_pounds", label: _t("prime_cheek_10_pounds", "Prime Cheek - 10 Pounds") },
    { value: "prime_cheek_20_pounds", label: _t("prime_cheek_20_pounds", "Prime Cheek - 20 Pounds") },
    { value: "prime_strip_20_pounds", label: _t("prime_strip_20_pounds", "Prime Strip - 20 Pounds") },
    { value: "seconds_cheeks_20_pounds", label: _t("seconds_cheeks_20_pounds", "Seconds Cheeks - 20 Pounds") },
    { value: "seconds_strips_20_pounds", label: _t("seconds_strips_20_pounds", "Seconds Strips - 20 Pounds") },
    { value: "seconds_tapitas_20_pounds", label: _t("seconds_tapitas_20_pounds", "Seconds Tapitas - 20 Pounds") },
    { value: "seconds_pieces_20_pounds", label: _t("seconds_pieces_20_pounds", "Seconds Pieces - 20 Pounds") },
    { value: "paste_20_pounds", label: _t("paste_20_pounds", "Paste - 20 Pounds") },
  ];

  const listItems = [
    {
      label: _t("boxes_in_refrigerator", "Boxes in Refrigerator"),
      value: summaryData?.data?.boxes_refrigerator ?? 0,
      icon: BoxOrange,
    },
    {
      label: _t("prime_cheek_pallets_10_pound", "Prime Cheek pallets (10 pound)"),
      value: summaryData?.data?.prime_cheek_10_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("prime_cheek_pallets_20_pound", "Prime Cheek pallets (20 pound)"),
      value: summaryData?.data?.prime_cheek_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("prime_strip_pallets_20_pound", "Prime Strip pallets (20 pound)"),
      value: summaryData?.data?.prime_strip_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("seconds_cheek_pallets_20_pound", "Seconds Cheek pallets (20 pound)"),
      value: summaryData?.data?.seconds_cheeks_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("seconds_strip_pallets_20_pound", "Seconds Strip pallets (20 pound)"),
      value: summaryData?.data?.seconds_strips_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("tapitas_20_pound", "Tapitas (20 pound)"),
      value: summaryData?.data?.seconds_tapitas_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("pieces_20_pound", "Pieces (20 pound)"),
      value: summaryData?.data?.seconds_pieces_20_pounds ?? 0,
      icon: Box,
    },
    {
      label: _t("pending_kg_third", "Pending KG 3rd"),
      value: summaryData?.data?.pending_kg_third  ?? 0,
      icon: Box,
      showEdit:true
    },
  ];
  
  useEffect(() => {
    refetch();
  }, [filter, refetch]);

  useEffect( () => {
    setLotNumber(convertToUserTimezone(date,"DDMMYY"));
  },[date]);  

  const handleEdit = (data) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };

  const handleSaved = () => {
    refetch();
    refetchSummary();
  };
  const columns = [
    {
      label: _t("date", "Date"),
      accessor: "created_at",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("pallet_code", "Pallet Code"),
      accessor: "pallet_code",
      cell: ({ value }) => formatPalletName(value),
    },
    {
      label: _t("packing_type", "Packing Type"),
      accessor: "packing_type",
      cell: ({ value }) =>
        value
          ?.split("_")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
    },
    {
      label: _t("total_boxes", "Total Boxes"),
      accessor: "box_number",
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span className={value === "sold" ? "cmn_badge" : "cmn_badge inactive"}>
          {/* {value === "sold" ? "Sold" : "Stored"} */}
          {_t(value , value)}
        </span>
      ),
    },

    {
      label: _t("refrigeration_actions", "Edit/Processing"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          {row.status === "stored" ? (
            <Button
              size="small"
              label={_t("edit", "Edit")}
              className="borderRedBtn"
              onClick={() => handleEdit(row)}
            />
          ) : (
            <span>{convertToUserTimezone(row.status_updated_at)}</span>
          )}
        </>
      ),
    },
  ];
  return (
    <div>
      {addRecord && (
        <RefrigerationModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
          packingTypeOptions={packingTypeOptions}
          onSuccess={handleSaved}
        />
      )}
      {showUpdateKgModal && (
        <UpdateRefrigerationPendingKgModal
          show={showUpdateKgModal}
          setShow={setShowUpdateKgModal}
          currentKg={summaryData?.data?.pending_kg_third || 0}
        />
      )}
      <div className="overview cmn_card mb-3">
        {/* <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("refrigeration_overview", "Refrigeration Overview")}
          </h6>
          <DateSelector setDate={setDate} />
        </div> */}
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
                key={index}
                title={list.label}
                value={list.value}
                icon={list.icon}
                day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
                showDay={false}
                showEdit={list.showEdit}
                onEdit={handleEditPendingKg}
              />
          ))}
        </ul>
      </div>      
      <Datatable
        title={_t(
          "brokerage_refrigeration_room",
          "Brokerage Refrigeration Room"
        )}
        columns={columns}
        tableData={refrigerationData?.data}
        onPageChange={handlePageChange}
        page={page}
        buttons={[
          {
            label: _t("add_refrigeration_data", "Add Refrigeration Data"),
            onClick: handleAddRefrigerationData,
            icon: PlusSvg,
          },
        ]}
        showFilter={setFilter}
        showFilterButton={true}
        filterModule="brokerage_refrigeration_filter"
        filters={filter}
        isLoading={isLoading || isFetching}
      />      
    </div>
  );
};

export default BrokerageRefrigeration;
